export interface ApiClientConfig {
  /** localStorage key for JWT token. Defaults to "pulsejwt". */
  jwtKey?: string;
  /** Optional token getter; overrides the localStorage[jwtKey] lookup. */
  getToken?: () => string | null;
  /** Called on 401 / 410 responses — handle session expiry (redirect, clear auth, etc). */
  onSessionExpiry?: () => void;
  /** Called on 401 / 403 / 410 responses with the exact status code. */
  onAuthError?: (status: number) => void;
  /**
   * Environment slug to use when running on localhost (e.g. "cs-dev", "dev").
   * Defaults to "dev".
   */
  localhostEnv?: string;
}

let _config: ApiClientConfig = { jwtKey: "pulsejwt" };

export function configureApiClient(c: ApiClientConfig): void {
  _config = { ..._config, ...c };
}

export function getApiConfig(): ApiClientConfig {
  return _config;
}

const LOCALHOST_RE = /^https?:\/\/localhost(?::\d+)?/;

function resolveEnv(origin: string): string {
  if (LOCALHOST_RE.test(origin)) return _config.localhostEnv ?? "dev";
  // origin is e.g. "https://halo.clearstreet.tokyo.pulseprime.io"
  // parts[1] is the environment slug (e.g. "clearstreet", "cs-dev")
  return origin.split(".")[1];
}

export function resolveCurrentEnv(): string {
  return resolveEnv(window.location.origin);
}

/**
 * Resolves a full service URL for the current environment.
 */
export function resolveServiceUrl(
  service: string,
  protocol: "https" | "wss" = "https",
): string {
  const env = resolveEnv(window.location.origin);
  const tld = env === "clearstreet" || env === "staging" ? "io" : "systems";
  return `${protocol}://${service}.${env}.tokyo.pulseprime.${tld}`;
}

/** Resolves the api-gateway base URL for the current environment. */
export function resolveBaseUrl(): string {
  return resolveServiceUrl("api-gateway");
}
